/**
 * Leaders in Action Slider
 * -----------------------------------------------------------------------------
 */

// Imports
const $              = require( 'jquery' );
const { MediaQuery } = require( '../../utilities/_media-query' );
const debounce       = require( '../../utilities/_debounce' );



function liaSlider() {

  const NAMESPACE = '.und.lia-slider';
  const $sliders  = $( '.lia-slider' ).map( ( i, el ) => $( el ) );



  /**
   * Initialize accessible-slick.
   *
   * @param {jQuery} $el Container element. This is not the element that
   *                     accessible-slick is applied to.
   */
  function init( $el ) {
    
    const $sliderContainer = $el.find( '.home-card__expand__container' );

    toggleSlick( $sliderContainer );

    $( window ).on( `resize${NAMESPACE}` , debounce( () => toggleSlick( $sliderContainer ), 200 ) );

  }

  /**
   * Toggles accessible-slick slider on or off. 
   * 
   * @param {jQuery} $container Element that accessible-slick is applied to.
   */
  function toggleSlick( $container ) {

    if ( MediaQuery.atLeast( 'sm' ) ) {

      $container.find( '.home-card' ).attr( 'tabindex', '0' );

      if ( $container.hasClass( 'slick-initialized' ) ) {
        $container.slick( 'unslick' );
      }

    } else {

      $container.find( '.home-card' ).removeAttr( 'tabindex' );
      
      if ( !$container.hasClass( 'slick-initialized' ) ) {
        $container.slick( { arrows: false } );
      }

    }
    
  }



  if ( $sliders.length ) {

    import( 'accessible_slick_script' )
      .then( ( res ) => {
        
        MediaQuery._init();
        $sliders.map( ( i, $el ) => init( $el ) );
      
      } )
      .catch( ( e ) => console.log( e ) );

  }

}


liaSlider();